import React, { useEffect, useRef } from "react";
import { Box } from "../Box";
import { IInputProps, Input } from "src/components/Input";
import { ComboBoxPanel } from "./ComboBox.panel";
import { IComboBoxOption, useComboBoxContext } from "./ComboBox.context";
import { observer } from "mobx-react-lite";
import { CaretDown } from "@asphalt-react/iconpack";
import styled from "styled-components";

export type IComboBoxProps = IInputProps & {
  options: IComboBoxOption[];
  onChange?: (option: IComboBoxOption) => void;
  dropdown?: boolean;
  value?: string;
  defaultValue?: string;
};

const InputWrapperEl = styled(Box)`
  > :first-child {
    flex-grow: 1;
  }
`;

type ComboBoxComponentProps = {
  label?: string;
};

export const ComboBoxComponent = observer((props: ComboBoxComponentProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const context = useComboBoxContext();
  const {
    props: { dropdown, onChange, ...others },
  } = context;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = context.currentInput;
    }
  }, [context.currentInput]);

  return (
    <Box style={{ position: "relative" }}>
      <InputWrapperEl flex flexDirectionRow>
        <Input
          {...others}
          innerRef={inputRef}
          autoComplete="off"
          onFocus={context.onInputFocus}
          onChange={(e) => {
            context.currentInput = e.target.value;
            context.showAll = false;
          }}
          label={props.label}
          readOnly={dropdown}
          outline={dropdown}
          qualifier={dropdown && <CaretDown />}
          reverseQualifier={dropdown}
        />
      </InputWrapperEl>
      <ComboBoxPanel />
    </Box>
  );
});
